import cn from 'classnames';
import Image from 'next/image';
import { Banknote, RefreshCw, ShieldCheck, Truck } from 'lucide-react';
import i18n from '@/settings/i18n';
import { priceFormater } from '@/settings';
import { priceFormatSuperscript } from '@/lib/price';
import type { TradeInQuoteT } from '@/lib/trade-in-quote';

const t = i18n.init('buyback');

const USPS = [
  { label: 'Ship for Free', Icon: Truck },
  { label: 'Data Wiped', Icon: ShieldCheck },
  { label: 'Get Paid Fast', Icon: Banknote },
] as const;

const TradeInQuoteCard = ({
  quote,
  onRemove,
  className,
  showHeading = true,
}: {
  quote: TradeInQuoteT;
  onRemove: () => void;
  className?: string;
  showHeading?: boolean;
}) => (
  <div className={cn('mb-2', className)}>
    {showHeading && <h2 className="mb-2 text-sm font-bold">{t`Trade-in`}</h2>}
    <div className="rounded-lg border border-gray-700 bg-white text-xs text-gray-700">
      <div className="flex items-center gap-2.5 px-4 py-3">
        {quote.thumbnail ? (
          <Image
            src={quote.thumbnail}
            alt=""
            aria-hidden="true"
            width={24}
            height={24}
            className="h-6 w-6 shrink-0 object-contain"
            unoptimized
          />
        ) : (
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-700 text-white">
            <RefreshCw className="h-3.5 w-3.5" strokeWidth={2.5} />
          </span>
        )}
        <span className="flex-1 font-bold">{quote.name}</span>
        <span className="shrink-0 text-right" translate="no">
          <span className="text-gray-700/60">{t`Trade-in value`}</span>{' '}
          <span className="font-bold text-[#128452]">
            {priceFormatSuperscript(priceFormater.long(quote.value))}
          </span>
        </span>
      </div>
      <div className="mx-4 h-px bg-[#E5E7EB]"></div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 px-4 py-3">
        {USPS.map(({ label, Icon }) => (
          <span key={label} className="flex items-center gap-1.5">
            <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={1.5} />
            {t(label)}
          </span>
        ))}
        <button
          type="button"
          onClick={onRemove}
          className="ml-auto shrink-0 text-gray-700/60 underline transition hover:text-gray-700"
        >
          {t`Remove`}
        </button>
      </div>
    </div>
  </div>
);

export default TradeInQuoteCard;
